import React from 'react';
import { Navigate } from 'react-router-dom';
import { isFeatureEnabledForCurrentTenant } from '@warehouse/shared/config';

export function HomeRedirect() {
	const landingPath = isFeatureEnabledForCurrentTenant('top-bar-dashboard-button') ? '/dashboard' : '/titles';
	return <Navigate replace to={landingPath} />;
}
